// El layout raiz apaga el SSR (la app es una SPA), asi que el prerender de
// cualquier ruta genera un shell vacio y el contenido lo pinta el navegador.
// Para esta pagina eso no sirve: /planes es publica y se llega por Google o por
// el link de un mail, asi que tiene que servir HTML con texto de verdad. Mismo
// tratamiento que /privacidad.
//
// Los planes en si NO se hornean en el build: se piden a la API desde el
// navegador. La tabla `subscription_plans` es la unica fuente de precios
// (decision de negocio #3) y hornearlos dejaria precios viejos hasta el proximo
// deploy.
export const ssr = true;
export const prerender = true;
